import { useSelector } from "react-redux";
import { RootState } from "@store/store";

const useInterfaceConfigV2 = () => {
  const interfaceConfig = useSelector((state: RootState) => state.brand.interface);
  return interfaceConfig;
};

export default useInterfaceConfigV2;
